import { useState } from "react"
import ClaroMultiBffService from "../services/ClaroMultiBffService"
import { SessionBySmsPayload } from "../types/ClaroMultiBff"

const useClaroMultiBff = () => {

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [customerData, setCustomerData] = useState(null)
  const [sessionBySms, setSessionBySms] = useState(null)

  const getSessionBySms = async ({
    cpf,
    msisdn,
    code,
    token
  }: SessionBySmsPayload) => {
    setLoading(true)
    setError(null)

    try {
      const response = await ClaroMultiBffService.getSessionBySms({
        cpf,
        msisdn,
        code,
        token
      })

      setSessionBySms(response.data)
      
      return {
        status: "success",
        data: response.data
      }
    } catch (error) {
      setError(error)
      return {
        status: "invalid",
        data: null
      }
    } finally {
      setLoading(false)
    }
  }

  const getCustomerData = async (tokenId: string) => {
    setLoading(true)
    setError(null)

    try {
      const response = await ClaroMultiBffService.getCustomerData({
        tokenId
      })
      
      setCustomerData(response.data)

      return {
        status: "success",
        data: response.data
      }
    } catch (error) {
      setError(error)
      return {
        status: "invalid",
        data: null
      }
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    error,
    sessionBySms,
    customerData,
    getSessionBySms,
    getCustomerData
  }
}

export default useClaroMultiBff
